<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >SERVICES INFORMATION</v-alert
        >
        <v-progress-linear
            v-if="!isShow"
            indeterminate
            color="cyan"
            class="mb-5"
        ></v-progress-linear>

        <v-card-text>
            <v-container v-if="isShow">
                <v-row>
                    <v-col
                        v-if="this.condition.status == 'subcase'"
                        cols="12"
                        sm="12"
                        md="6"
                    >
                        <v-text-field
                            v-model="information.subcase_title"
                            label="Sub Case Title"
                            filled
                            :rules="[
                                (v) => !!v || 'Sub Case Title is required',
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        v-if="this.condition.status == 'subcase'"
                        cols="12"
                        sm="12"
                        md="6"
                    >
                        <v-textarea
                            v-model="information.remark"
                            label="Remark"
                            filled
                            height="30"
                            outlined
                        ></v-textarea>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                            v-model="information.site_name"
                            label="Site Name / Company Name"
                            :rules="[(v) => !!v || 'SiteName is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                            v-model="information.site_address"
                            label="Site Address"
                            :rules="[(v) => !!v || 'Adress is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="3">
                        <v-text-field
                            v-model="information.site_postcode"
                            :value="information.site_postcode"
                            label="รหัสไปรษณีย์"
                            @blur="clearData('postcode')"
                            hint=" * กรอกรหัสไปรษณีย์หรือเลือกจังหวัด"
                            persistent-hint
                            :rules="[(v) => !!v || 'PostCode is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="3">
                        <v-select
                            :items="address"
                            v-model="information.site_district_id"
                            item-text="district_name_th"
                            item-value="district_id"
                            label="ตำบล / แขวง"
                            @change="getAddressAll()"
                            dense
                            outlined
                            :rules="[(v) => !!v || 'District is required']"
                        ></v-select>
                    </v-col>

                    <v-col cols="6" sm="3" md="3">
                        <v-select
                            v-model="information.site_amphur_id"
                            :items="amphur"
                            item-text="amphur_name_th"
                            item-value="amphur_id"
                            label="อำเภอ / เขต"
                            dense
                            outlined
                            @change="getDistricts()"
                            :rules="[(v) => !!v || 'Amphur is required']"
                        ></v-select>
                    </v-col>

                    <v-col cols="6" sm="3" md="3">
                        <v-select
                            v-model="information.site_province_id"
                            :items="address_data"
                            item-text="province_name_th"
                            item-value="province_id"
                            label="จังหวัด"
                            dense
                            outlined
                            @change="clearData('province')"
                            :rules="[(v) => !!v || 'Province is required']"
                        ></v-select>
                    </v-col>
                    <v-col
                        v-if="condition.team == 'NONHP'"
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-checkbox
                            @change="
                                information.clearbyphone = !information.clearbyphone
                            "
                            :label="`Clear By Phone ? `"
                        ></v-checkbox>
                    </v-col>
                    <v-col
                        v-if="condition.team == 'NONHP'"
                        cols="12"
                        sm="6"
                        md="8"
                    ></v-col>

                    <v-col
                        v-if="!information.clearbyphone"
                        cols="12"
                        sm="6"
                        md="3"
                    >
                        <v-select
                            :items="svc"
                            v-model="information.branch_id"
                            item-text="branch_name"
                            item-value="branch_id"
                            label="Zone"
                            dense
                            outlined
                            menu-props="auto"
                            @change="getEngineer()"
                            :rules="[(v) => !!v || 'Zone is required']"
                        ></v-select>
                    </v-col>
                    <v-col
                        v-if="!information.clearbyphone"
                        cols="12"
                        sm="6"
                        md="3"
                    >
                        <v-select
                            @change="changeEngineer()"
                            :items="engineer"
                            v-model="information.engineer"
                            item-text="emp_name_en"
                            item-value="emp_id"
                            label="Engineer"
                            dense
                            outlined
                            :rules="[(v) => !!v || 'Engineer is required']"
                        ></v-select>
                    </v-col>
                    <v-col
                        v-if="information.engineer != 'ZONE'"
                        cols="12"
                        sm="6"
                        md="3"
                    >
                        <v-menu
                            v-model="datemenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="computedDateFormatted"
                                    label="Date Onsite"
                                    hint="YYYY-MM-DD format"
                                    readonly
                                    dense
                                    v-on="on"
                                    outlined
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                :min="today"
                                v-model="date"
                                no-title
                                @input="datemenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        v-if="information.clearbyphone"
                        cols="12"
                        sm="6"
                        md="4"
                    >
                        <v-textarea
                            v-model="information.clearbyphone_remark"
                            label="Remark"
                            filled
                            height="80"
                            outlined
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col
                        v-if="
                            information.engineer != 'ZONE' &&
                                date == today &&
                                information.case_type != 'bench'
                        "
                        cols="12"
                        sm="6"
                        md="3"
                    >
                        <v-select
                            :items="schedule"
                            item-text="schedule_range"
                            item-value="schedule_id"
                            v-model="information.timeonsite"
                            label="Schedule Time Onsite"
                            dense
                            outlined
                        ></v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-snackbar
            v-if="
                information.cdax_log !== null &&
                    information.cdax_log != '' &&
                    information.cdax_log !== undefined &&
                    information.cdax_log.log != '' &&
                    condition.team != 'NONHP' &&
                    showcdaxlog == true
            "
            color="white"
            :timeout="0"
            bottom
            right
            v-model="snackbar"
        >
            <v-row>
                <v-col cols="12">
                    <v-btn
                        @click="showcdaxlog = !showcdaxlog"
                        style="margin-left: 220px"
                        icon
                    >
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <v-textarea
                        v-model="computedLog"
                        label="CDAX LOG"
                        filled
                        height="300"
                        outlined
                    ></v-textarea>
                </v-col>
            </v-row>
        </v-snackbar>
        <v-snackbar
            v-if="
                information.cdax_log !== null &&
                    information.cdax_log != '' &&
                    information.cdax_log !== undefined &&
                    information.cdax_log.log != '' &&
                    condition.team != 'NONHP' &&
                    showcdaxlog == false
            "
            color="white"
            :timeout="0"
            bottom
            right
            v-model="snackbar"
            style="width: 116%"
        >
            <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                @click="showcdaxlog = !showcdaxlog"
            >
                <v-icon dark> mdi-plus </v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["information", "condition"],
    // created() {
    //   if (
    //     this.condition.status == "editcase" ||
    //     this.condition.status == "subcase"
    //   ) {
    //     _.delay(this.getAddress, 2000);
    //   }
    // },
    data() {
        return {
            snackbar: true,
            address: [],
            amphur: [],
            province: [],
            svc: [],
            engineer: [],
            address_data: [],
            datemenu: false,
            today: new Date().toISOString().substr(0, 10),
            date: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000)
                .toISOString()
                .substr(0, 10),
            schedule: [],
            isShow: false,
            isChangeCE: false,
            showcdaxlog: false,
        }
    },
    // watch: {
    //     "information.site_postcode": function(newQuestion, oldQuestion) {
    //         if (this.condition.status == "editcase") {
    //             this.getAddress()
    //             this.date = this.information.onsite_at
    //             this.information.timeonsite =
    //                 this.information.schedule_range_id !== null
    //                     ? this.information.schedule_range_id
    //                     : ""
    //         }
    //     },
    // },
    watch: {
        "information.site_postcode": function(newQuestion, oldQuestion) {
            if (
                this.information.project_id == "54" ||
                this.information.project_id == "56"
            ) {
                this.getAddress()
            }
            if (this.condition.status == "editcase") {
                this.getAddress()
                this.date = this.information.onsite_at
                this.information.timeonsite =
                    this.information.schedule_range_id !== null
                        ? this.information.schedule_range_id
                        : ""
            }
        },
        isShow: function(newQuestion, oldQuestion) {
            if (newQuestion) {
                setInterval(() => {
                    this.$emit("showform")
                }, 1000)
            }
        },
    },
    mounted() {
        if (
            this.condition.status == "ViewDetail" &&
            this.information.site_postcode == ""
        ) {
            this.isShow = true
        }
        this.getProvince()
        this.getSchedule()
        if (
            this.information.site_postcode != "" &&
            this.condition.status != "editcase"
        ) {
            this.getAddress()
        }
        if (
            this.condition.team == "INVENTORY" &&
            this.information.subcase_title === null
        ) {
            this.information.subcase_title =
                "Inventory sent to Bench NONHP repair"
        }
    },
    methods: {
        changeEngineer() {
            if (this.information.engineer === "ZONE") {
                this.information.dateonsite = null
            }
            this.isChangeCE = true
        },
        clearData(type) {
            this.information.site_district_id = ""
            this.information.site_amphur_id = ""
            this.information.branch_id = ""
            this.information.engineer = ""
            if (type == "postcode") {
                this.information.site_province_id = ""
                this.getAddress()
            } else if (type == "province") {
                this.information.site_postcode = ""
                this.getAmphur()
            }
        },
        async getSchedule() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/schedule-time`
            try {
                const { data } = await axios.get(url)
                this.schedule = data
            } catch (error) {
                console.log(error)
            }
        },
        getDistricts() {
            this.amphur.map((each) => {
                if (each.amphur_id == this.information.site_amphur_id) {
                    this.address = [...each.districts]
                }
            })
        },
        getAmphur() {
            this.address_data.map((each) => {
                if (each.province_id == this.information.site_province_id) {
                    this.amphur = [...each.amphures]
                }
            })
        },
        async getProvince() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/thaiaddress`
            try {
                const { data } = await axios.get(url)
                this.address_data = data
            } catch (error) {
                console.log(error)
            }
        },
        async getAddress() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/getdistricts`
            const body = {
                site_postcode: this.information.site_postcode,
            }
            try {
                const { data } = await axios.post(url, body)
                this.address = data
                if (
                    this.condition.status == "editcase" ||
                    this.condition.status == "subcase"
                ) {
                    this.getAddressAll()
                }
                this.isShow = true
            } catch (error) {
                console.log(error)
            }
        },
        getAddressAll() {
            if (this.information.site_postcode != "") {
                var amphur = {}
                this.amphur = []
                this.address.map((each) => {
                    amphur = {
                        amphur_id: each.amphur_id,
                        amphur_name_th: each.amphur_name_th,
                    }
                    this.amphur.push(amphur)
                    if (each.district_id == this.information.site_district_id) {
                        this.information.site_amphur_id = each.amphur_id

                        this.province = each.province_name_th
                        this.information.site_province_id = each.province_id

                        this.getSVCEngineer()
                    }
                })
            } else {
                this.address.map((each) => {
                    if (each.district_id == this.information.site_district_id) {
                        this.information.site_postcode = each.zip_code
                    }
                })
                this.getSVCEngineer()
            }
        },
        async getSVCEngineer() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }
            // const url = `${process.env.VUE_APP_ROOT_API}/api/svc-zone-ce/${this.information.site_province_id}/${this.information.site_amphur_id}`;
            const url = `${process.env.VUE_APP_ROOT_API}/api/get-zone-ce/${this.information.site_province_id}`
            try {
                const { data } = await axios.get(`${url}`, options)
                if (
                    data[0].branch_name == "ODM" ||
                    this.information.branch_id == ""
                ) {
                    this.information.branch_id = data[0].branch_id
                }
                this.svc = data
                this.getEngineer()
            } catch (error) {
                console.log(error)
            }
        },
        getEngineer() {
            this.svc.map((each) => {
                if (each.branch_id == this.information.branch_id) {
                    this.engineer = ["ZONE", ...each.engineer]
                }
            })
            if (this.information.engineer == "" || this.isChangeCE) {
                this.information.engineer = "ZONE"
                this.isChangeCE = false
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
    },
    computed: {
        computedDateFormatted() {
            this.information.dateonsite = null
            if (this.information.engineer != "ZONE") {
                this.information.dateonsite = this.formatDate(this.date)
            }
            return this.information.dateonsite
        },
        computedLog() {
            const textshow =
                this.information.cdax_log.log !== undefined
                    ? this.information.cdax_log.log
                    : this.information.cdax_log
            return textshow
        },
    },
}
</script>
<style scoped>
.v-messages__message {
    color: red;
}
</style>
